module.exports = __webpack_public_path__ + "img/start_4.884261fe.svg";